import React, { Component } from 'react'
import _ from 'lodash'
import uuid from 'uuid/v4'
import Repository from '../../felles/repository'
import Loading from '../../felles/loading'
import Vannmaaler from './vannmaaler'
import { resolve } from '../../dependencies'
import { Link } from 'react-router-dom'
import { AppInsights } from 'applicationinsights-js'
import NKIcon from '@norkart/ikoner'

import './vannmaaler.css'

export default class VannmaalerContainer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            Eiernavn: '',
            Eieradresse: '',
            MaalepunktAdresse: '',
            Mobilnummer: '',
            MaalepunktNummer: '',
            MaalerNummer: '',
            Plassering: '',
            PlasseringId: -1,
            PlasseringFritekst: '',
            Retning: '',
            Avtaletype: '',
            Dimensjon: '',
            BytteId: uuid(),
            BytterMaaler: false,
            MaalerbytteOk: false,
            AvleserType: '',
            Egentype: [],
            laster: true,
            loadingText: 'Henter målerdata'
        }

        this._hentVannmaalerInfo = this._hentVannmaalerInfo.bind(this)

        this._onDataReceived = this._onDataReceived.bind(this)
        this._endrePlassering = this._endrePlassering.bind(this)
        
        this._utfoerMaalerSkifte = this._utfoerMaalerSkifte.bind(this)
        this._etterMaalerSkifte = this._etterMaalerSkifte.bind(this)

        this._gaaTilArbeidsliste = this._gaaTilArbeidsliste.bind(this)
    }

    componentDidMount() {
        AppInsights.trackPageView('Bytt måler')
        Promise.all([
            this._hentPlasseringer(),
            this._hentVannmaalerInfo(),
            this._hentEgendefinerteType()
        ]).then(this._onDataReceived)
    }

    _onDataReceived(data) {
        var maaler = data[1]

        var allePlasseringer = data[0]

        var aktuellPlasseringForSelect = _.find(
            allePlasseringer,
            p => p.Tekst === maaler.Plassering
        )

        var plasseringFraTypetabell = !aktuellPlasseringForSelect
            ? ''
            : aktuellPlasseringForSelect.Tekst
        var plasseringFritekst = !aktuellPlasseringForSelect ? maaler.Plassering : ''
        var plasseringId = !aktuellPlasseringForSelect ? -1 : aktuellPlasseringForSelect.Id
        var alleEgentdefinerteType = data[2]
        var adresse = maaler.Maaleradresse + ' ' + maaler.Husnummer + ' ' + maaler.Husbokstav
        AppInsights.trackTrace('hentet data for bytte ' + this.state.BytteId +' med adresse '+adresse, {bytteId:this.state.BytteId, MaalerId:maaler.Vmid})

        this.setState({
            Eiernavn: maaler.Eiernavn,
            Eieradresse: maaler.EierAdresse,
            MaalepunktAdresse:
                maaler.Maaleradresse + ' ' + maaler.Husnummer + ' ' + maaler.Husbokstav,
            Mobilnummer: maaler.Mobilnr,
            Telefonnummer: maaler.Telefon,
            MaalepunktId: maaler.Vmpid,
            MaalerNummer: maaler.Maalernummer,
            MaalerId: maaler.Vmid,
            PlasseringId: plasseringId,
            Plassering: plasseringFraTypetabell,
            PlasseringFritekst: plasseringFritekst,
            Retning: maaler.Retning,
            Avtaletype: maaler.Avtaletype,
            Dimensjon: maaler.Dimensjon,
            Plasseringer: allePlasseringer,
            SisteStand: maaler.Forrigestand,
            SisteForbruk: maaler.ForrigeForbruk,
            SisteAvlesningsdato: maaler.ForrigeAvlesningsdato,
            Avlesningstype: maaler.Avlesningstype,
            Egentype: alleEgentdefinerteType,
            laster: false
        })
    }
    _hentVannmaalerInfo() {
        return resolve(Repository).hentVannmaalerMedId(
            this.props.match.params.Id,
            this.props.match.params.ListeId
        )
    }

    _hentEgendefinerteType() {
        return resolve(Repository).hentEgendefinerteMaalertyper()
    }

    _hentPlasseringer() {
        return resolve(Repository).hentPlasseringer()
    }

    _endrePlassering(tekst) {
        this.setState({
            Plassering: tekst
        })
    }  

    _utfoerMaalerSkifte(bytteData, loraEuid) {
        this.setState({
            BytterMaaler: true
        })

        bytteData.GammelvannmaalerId = this.state.MaalerId
        bytteData.MaalepunktId = this.state.MaalepunktId

        let byttedataSomSkalSendes = {
            BytteId: this.state.BytteId,
            ArbeidslisteId: this.props.match.params.ListeId,
            BytteData: bytteData,
            LoraEuid: loraEuid
        } 

        AppInsights.trackTrace('skal sende byttedata ' + this.state.BytteId , {bytteId:this.state.BytteId, byttedData:JSON.stringify(bytteData)})

        resolve(Repository)
            .utforeMaalerSkifte(byttedataSomSkalSendes) 
            .then(res => this._etterMaalerSkifte(res))
    }

    _etterMaalerSkifte(res) {
        this.setState({
            BytterMaaler: false,
            MaalerbytteOk: res > 0
        })

        if (res > 0) {
            AppInsights.trackEvent('Målerskifte utført ' + this.state.BytteId)
            this.props.history.goBack()
        } else {
            alert('Noe gikk galt')
        }
    }

    _gaaTilArbeidsliste() {
        this.setState({
            BytterMaaler: false
        })
        this.props.history.goBack()
    }

    render() {
        let maalerInfoForIkkeskifet = {
            MaalepunktAdresse: this.state.MaalepunktAdresse,
            Eiernavn: this.state.Eiernavn,
            Mobilnummer: this.state.Mobilnumme,
            Telefonnummer: this.state.Telefonnummer,
            Avtaletype: this.state.Avtaletype,
            MaalepunktId: this.state.MaalepunktId,
            MaalerNummer: this.state.MaalerNummer
        }

        if (this.state.laster) {
            return <Loading tekst={this.state.loadingText} />
        }

        return (
            <div className="listeContainer">
                {this.state.BytterMaaler ? (
                    <Loading tekst="Registrer bytte" />
                ) : (
                    <div>
                        <Vannmaaler
                            Eiernavn={this.state.Eiernavn}
                            Eieradresse={this.state.Eieradresse}
                            MaalepunktAdresse={this.state.MaalepunktAdresse}
                            Mobilnummer={this.state.Mobilnummer}
                            Telefonnummer={this.state.Telefonnummer}
                            MaalepunktNummer={this.state.MaalepunktNummer}
                            MaalerNummer={this.state.MaalerNummer}
                            Plassering={this.state.Plassering}
                            PlasseringId={this.state.PlasseringId}
                            Avtaletype={this.state.Avtaletype}
                            Retning={this.state.Retning}
                            Dimensjon={this.state.Dimensjon}
                            Plasseringer={this.state.Plasseringer}
                            endrePlassering={this._endrePlassering}
                            SisteStand={this.state.SisteStand}
                            SisteForbruk={this.state.SisteForbruk}
                            SisteAvlesningsdato={this.state.SisteAvlesningsdato}
                            PlasseringFritekst={this.state.PlasseringFritekst}                            
                            utfoerMaalerSkifte={this._utfoerMaalerSkifte}
                            Retninger={this.state.Retninger}
                            VannmaalerTyper={this.state.Egentype}
                            maalerIkkeSkifet={this._maalerIkkeSkiftet}
                            Fabrikater={this.state.FabrikatTyper}
                            Dimensjoner={this.state.Dimensjoner}
                            Avlesningstype={this.state.Avlesningstype}
                            BytteId={this.state.BytteId}
                        />
                        <div className="container">
                            <Link
                                to={{
                                    pathname: this.props.location.pathname + '/ikkeskiftet/',
                                    state: { maalerInfoForIkkeskifet }
                                }}
                                className="list-group-item ikkeskiftetmaalerKnapp"
                            >
                                <div style={{ float: 'right', overflow: 'hidden' }}>
                                    <NKIcon icon="hoyrepil" color="nk-black" size="1" />
                                </div>
                                <div style={{ overflow: 'hidden' }}>
                                    <span className="pull-left margin-left-10">
                                        <NKIcon icon="advarsel_roed" size="1" color="nk-black" />
                                    </span>

                                    <div style={{ display: 'inline' }}>
                                        <div className="midstillTekst">Ikke skiftet måler</div>
                                    </div>
                                </div>

                                <div style={{ float: 'none', clear: 'both' }} />
                            </Link>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/utskiftning/vannmaalere/vannmaalerContainer.jsx